import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { email, validateDPI } from '../../../../utility/validation';
import { renderField, renderNumber } from '../../Utils/renderField';


const ForgotForm = (props) => {
    const { handleSubmit } = props;
    return (
        <form name="loginForm" className="form-validate mb-lg" onSubmit={handleSubmit}>
            <div className='form-group has-feedback'>
                <Field
                    type='text'
                    name='username'
                    label='username'
                    component={renderNumber}
                    numberFormat={"#### ##### ####"}
                    className='form-control'
                    placeholder='No. de DPI'
                />
            </div>
            <div className="form-group has-feedback">
                <Field
                    name="email"
                    label="Correo Electronico"
                    component={renderField}
                    type="email"
                    className="form-control"
                    placeholder="Correo electrónico"
                />
            </div>
            <div className="form-group has-feedback">
                <Field
                    name="confirm_email"
                    label="Confirma el correo electrónico"
                    component={renderField}
                    type="email"
                    className="form-control"
                    placeholder="Confirma el correo electrónico"
                />
            </div>
            <div className="buttons-box">
                <button type="submit" className="btn btn-primary btn-block m-1 align-self-center font-weight-bold">Restablecer contraseña</button>
            </div>
        </form>
    );
};

export default reduxForm({
    form: 'forgot', // a unique identifier for this form
    validate: (data) => {
        const errors = {};
        if (!data.username) {
            errors.username = 'Este campo es requerido';
        } else {
            const dpiError = validateDPI(data.username);
            if (dpiError) {
                errors.username = 'El DPI debe tener 13 dígitos';
            }
        }

        if (!data.email) {
            errors.email = 'Este campo es requerido';
        } else if (email(data.email)) {
            errors.email = 'Email invalido';
        }

        if (!data.confirm_email) {
            errors.confirm_email = 'Este campo es requerido';
        } else if (data.email !== data.confirm_email) {
            errors.confirm_email = 'Los emails no coinciden';
        }

        return errors;
    },
})(ForgotForm);
